export function downloadBase64File(base64Data, filename) {
    if (!!base64Data && !!filename) {
        const linkSource = `data:application/pdf;base64,${base64Data}`;
        const downloadLink = document.createElement('a');

        downloadLink.href = linkSource;
        downloadLink.download = filename;
        downloadLink.click();
    }
}

export function downloadZip(base64Data, linkArquivo) {
    const link = document.createElement('a');
    link.href = linkArquivo;
    link.download = base64Data;
    link.click();
}

export const openBase64File = (base64Data) => {
    const contentType = 'application/pdf';

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: contentType });

    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
    setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
}